import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import CTABand from "../components/CTABand";
import { Stagger, StaggerItem } from "../components/Reveal";
import { COUNTIES, REGIONS } from "../data/counties";
import { breadcrumbSchema, organizationSchema } from "../lib/schema";

export default function Areas() {
  const crumbs = [
    { name: "Home", path: "/" },
    { name: "Areas We Serve", path: "/areas-we-serve" },
  ];
  return (
    <>
      <SEO
        title="Areas We Serve | Online Therapy in Every NJ County"
        description="NJ Therapy Online provides virtual therapy in all 21 New Jersey counties — Bergen, Morris, Essex, Monmouth, Middlesex, Ocean, Camden and more. Find your county."
        path="/areas-we-serve"
        schema={[breadcrumbSchema(crumbs), organizationSchema()]}
      />
      <PageHero
        crumbs={crumbs}
        eyebrow="Areas we serve"
        title="Online therapy in all 21"
        accent="New Jersey counties"
        body="From the Highlands to the Shore, our clinicians meet with clients statewide over secure video. Find your county below."
        testid="areas-hero"
      />

      <section className="section" data-testid="areas-regions">
        <div className="container-site space-y-14">
          {REGIONS.map((r) => (
            <div key={r}>
              <h2 className="text-2xl md:text-3xl">{r}</h2>
              <Stagger className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {COUNTIES.filter((c) => c.region === r).map((c) => (
                  <StaggerItem key={c.slug} className="h-full">
                  <Link
                    to={`/areas-we-serve/${c.slug}`}
                    className="card card-hover group block h-full p-6"
                    data-testid={`area-card-${c.slug}`}
                  >
                    <div className="flex items-center justify-between">
                      <h3 className="text-lg">{c.name} County</h3>
                      <ArrowRight className="h-4 w-4 text-[var(--sage)] opacity-50 group-hover:opacity-100 group-hover:translate-x-0.5 transition" />
                    </div>
                    <p className="mt-2 text-sm text-body leading-relaxed flex gap-1.5">
                      <MapPin className="h-4 w-4 shrink-0 mt-0.5 text-[var(--sage)]" />
                      <span>{c.cities.slice(0, 5).join(", ")} & more</span>
                    </p>
                  </Link>
                  </StaggerItem>
                ))}
              </Stagger>
            </div>
          ))}
        </div>
      </section>
      <CTABand />
    </>
  );
}
